import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { useTranslation } from "react-i18next";

const WorkScheduleDetailMain = () => {
  const {t} = useTranslation()
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
    </>
  );
};

export default WorkScheduleDetailMain;
